import { Payments } from "@/constants";
import { cn, createBEM } from "@/libs";
import { ComponentBase } from "@/types";
import { parsePayments } from "@/utils/tool";
import { Icon, IconName, IconProps } from "../Icon";
import "./index.scss";
export interface PaymentIconsProps extends ComponentBase.Component {
  payments: number;
  size?: IconProps["size"];
}
export const paymentsMapIconsName = {
  [Payments.BANK]: "bank",
  [Payments.ALI]: "alipay",
  [Payments.WE_CHAT]: "wechat",
  [Payments.CRYPTO_COIN]: "USDT",
  [Payments.DIGITAL_RMB]: "digital_rmb",
  [Payments.WX_GROUP]: "wechat"
};
export const PaymentIcons = ({
  payments,
  size
}: PaymentIconsProps) => {
  const b = createBEM("i-payment_icons");
  return <>
      {parsePayments(payments).map(item => {
      return <Icon name={(paymentsMapIconsName[item] as IconName)} className={cn(b("icon"))} key={item} size={size} />;
    })}
    </>;
};